import { api } from "../lib/api";
import { useLang } from "../lib/i18n";

export const LangToggle = ({ dark }) => {
  const { lang, setLang } = useLang();
  const pick = (l) => {
    setLang(l);
    if (localStorage.getItem("hf_token")) api.post("/auth/lang", { lang: l }).catch(() => {});
  };
  return (
    <div className={`flex rounded-lg overflow-hidden border-2 ${dark ? "border-white/30" : "border-slate-300"}`} data-testid="lang-toggle">
      {["es", "en"].map((l) => (
        <button key={l} type="button" data-testid={`lang-${l}`} onClick={() => pick(l)}
          className={`px-3 py-1.5 text-sm font-bold uppercase transition-colors ${lang === l ? (dark ? "bg-white text-slate-900" : "bg-slate-900 text-white") : dark ? "text-white" : "text-slate-700"}`}>
          {l}
        </button>
      ))}
    </div>
  );
};
